import {Directive, ElementRef, Input} from "@angular/core";

@Directive({
               selector  : "[csTestId]",
               exportAs  : "csTestId",
               standalone: true
           })
export class CsTestId
{
    private m_id: string;

    @Input("csTestId") set message(value: string)
    {
        this.m_id = value;
        this.apply();
    }

    constructor(private elementRef: ElementRef)
    {
    }

    private apply(): void
    {
        this.elementRef.nativeElement.setAttribute("o3-test-id", this.m_id);
    }
}

export interface WithTestId
{
    csTestId?: string;
}